import { categoryAction } from "../const";
export const getCategory = (data: any) => {
    return {
        type: categoryAction.GET_CATEGORY,
        payload: data,
    };
};
